import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { GetBetHistory } from '../Api/GetBetHistory';
import { Flip, toast } from 'react-toastify';
import NumberBetModal from './Numberbetmodal';
import { Helmet } from 'react-helmet';


export default function BetHistory() {

    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [isClient, setIsClient] = useState("");
    const [isGames, setIsGames] = useState("");

    const [betHistoryData, setBetHistoryData] = useState([]);
    const { setLoad, setLoadColor, numberModal, sideBarOpen, sessionDetail, setAllBetModalData, setAllBetModalStatus } = useContext(Context);


    const handleClientChange = (e) => {
        console.log("e.targetvalue", e.target.value)
        const value = e.target.value === '' ? null : e.target.value;
        setIsClient(value);
    };

    const handleGameChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsGames(value);
    };

    // const handleBetHistory = async () => {
    //     setLoad(true);
    //     setLoadColor("#434343");
    //     let data = {
    //         "username": JSON.parse(localStorage.getItem('userinfo'))?.username,
    //         "client_name": isClient,
    //         "game_name": isGames,
    //         "user_id": JSON.parse(localStorage.getItem('userinfo'))?.userId

    //     }
    //     let res = await GetBetHistory(data);
    //     if (res) {
    //         if (res.data.status) {
    //             console.log(res.data, "res.data of history");
    //             setBetHistoryData(res.data.data);
    //         }
    //         else {
    //             toast.error(res.data.message, {
    //                 position: "top-right",
    //                 autoClose: 1500,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "colored",
    //                 transition: Flip,
    //             });
    //         }
    //         setLoad(false);
    //     }
    //     setLoad(false);
    // }

    const handleBetHistory = useCallback(async () => {
        setLoad(true);
        setLoadColor("#434343");
        const data = {
            username: JSON.parse(localStorage.getItem('userinfo'))?.username,
            client_name: isClient,
            game_name: isGames,
            user_id: JSON.parse(localStorage.getItem('userinfo'))?.userId
        };

        try {
            const res = await GetBetHistory(data);
            if (res?.data?.status) {
                console.log(res.data, "res.data of history");
                setBetHistoryData(res.data.data);
            } else {
                toast.error(res.data.message, {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                });
            }
        } catch (error) {
            toast.error("Something went wrong while fetching data");
        } finally {
            setLoad(false);
        }
    }, [isClient, isGames, setLoad, setLoadColor]);

    useEffect(() => {
        if (isClient && isGames) {
            handleBetHistory();
        }
    }, [isClient, isGames, handleBetHistory]);
    useEffect(() => {
        if (pathname === "/betHistory" && !numberModal && !sideBarOpen) {
            handleBetHistory();
        }
    }, [pathname, numberModal, sideBarOpen, handleBetHistory]);
    return (
        <>
            <Helmet>
                {/* Page Title */}
                <title>Bet History | View Past Bets & Results | Matka Jantri</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="View the complete history of all past bets placed on Matka games for any client and game. Track your betting activity easily on MatkaJantri."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pushpabetfair.com/bet-history" />

                {/* Favicon and Icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Bet History | View Past Bets & Results | MatkaJantri" />
                <meta
                    property="og:description"
                    content="View the complete history of all past bets placed on Matka games for any client and game. Track your betting activity easily on MatkaJantri."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://pushpabetfair.com/bet-history" />
                <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
            </Helmet>

            <NumberBetModal />

            <div className='depositContainer'>
                <div className="wrapper" style={{ marginTop: "0px" }}>
                    <div className="section">
                        <div className="top_navbar" style={{ height: "60px" }}>
                            <div className="hamburger" >
                                <button className='back_btn' onClick={() => navigate("/game")} style={{ background: 'none', border: 'none' }}>
                                    <i className="fa-solid fa-chevron-left"></i>
                                </button>
                            </div>
                            <div className='gameName'>Jantri History</div>
                        </div>
                    </div>
                </div>

                <div className="Tablecontainer betHistorytableCss" >
                    <div className='SelectData'>
                        <div className='container-Section'>
                            <div className="select-section">
                                <select className="select-dropdown" onChange={handleClientChange}>
                                    <option value=''>Selects Client</option>
                                    {sessionDetail?.user_clients?.map((client, index) => (
                                        <option key={index} value={client} >{client}</option>
                                    ))}
                                </select>
                                <select className="select-dropdown" onChange={handleGameChange}>
                                    <option value=''>Select Games</option>
                                    {sessionDetail?.user_games?.map((games, index) => (
                                        <option key={index} value={games}>{games}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>Client Name</th>
                                <th>Game Name</th>
                                <th>Total Bet</th>
                                <th>Bet Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {betHistoryData?.map((ele, i) => {
                                return (
                                    <tr key={i}>
                                        <td >{ele?.client_name}</td>
                                        <td >{ele?.game_name}</td>
                                        <td onClick={() => { setAllBetModalStatus(true); setAllBetModalData(ele?.total_bet_obj?.details) }}>{ele?.total_bet_obj?.total_bets}</td>
                                        <td >{ele?.total_bet_obj?.total_amount}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
